import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../assets/css/connexion.css";

export default function Connexion() {
    const { t } = useTranslation("connexion");
    const [username, setUsername] = useState(""); // Utilisateur entre son nom d'utilisateur
    const [password, setPassword] = useState("");
    const [loginError, setLoginError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    const API_BASE_URL = process.env.REACT_APP_API_URL;

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoginError("");
        setIsSubmitting(true);

        try {
            const response = await fetch(`${API_BASE_URL}/api/admin/login`, {
                // URL modifiée
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    username: username,
                    password: password,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                localStorage.setItem("adminToken", data.token);
                navigate("/AdminDashboard");
            } else {
                setLoginError(data.message || t("loginFailed"));
            }
        } catch (error) {
            console.error("Erreur lors de la connexion:", error);
            setLoginError(t("networkError"));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="connexion-page">
            <div className="connexion-container">
                <h2 className="connexion-title">{t("title")}</h2>
                <form onSubmit={handleSubmit} className="connexion-form">
                    <div className="form-group">
                        <p>{t("usernameLabel")}</p>{" "}
                        {/* Utilisation de "Nom d'utilisateur" */}
                        <input
                            type="text" // Changer le type à "text" car c'est le nom d'utilisateur
                            id="username"
                            className="form-control"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)} // Mise à jour de l'état username
                            style={{ color: "white" }}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <p>{t("passwordLabel")}</p>
                        <input
                            type="password"
                            id="password"
                            className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    {loginError && (
                        <p className="error-message">{loginError}</p>
                    )}
                    <button
                        type="submit"
                        className="connexion-button"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? t("loggingIn") : t("loginButton")}
                    </button>
                    {/* Lien d'inscription retiré */}
                </form>
            </div>
        </div>
    );
}
